import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';

import { appActions } from '../../../actions';

import AdminPageLayout from '../layout';

import PortalApi from '../../../services/PortalApi';
import Utils from '../../../services/Utils';

class ContactTagIndexPage extends React.PureComponent {
  state = {
    contactTags: [],
  }

  async componentDidMount() {
    await this.loadContacts();
    this.props.finishLoading();
  }

  loadContacts = async () => {
    const contactTags = await PortalApi.admin.getContactTags();
    this.setState({
      contactTags,
    });
  }

  renderContactTags = () => {
    const { contactTags } = this.state;

    const columns = [
      {
        Header: '# ID',
        accessor: row => row.id.toString(),
        id: 'id',
        width: 100,
        Cell: ({ value: id }) => (
          <Link className="edit-link" to={`/admin/contact-tags/${id}`}>
            {id}
          </Link>
        ),
      },
      { Header: 'Name', accessor: 'name' },
    ];

    return (
      <div>
        <ReactTable
          data={contactTags}
          columns={columns}
          defaultPageSize={50}
          pageSizeOptions={[10, 25, 50, 100]}
          filterable
          defaultFilterMethod={Utils.reactTableFilterInsensitive}
        />
      </div>
    );
  }

  render() {
    const { className } = this.props;

    return (
      <div className={className}>
        <AdminPageLayout>
          <div className="main-content">
            <h1>Contacts Tag</h1>
            <Link to="/admin/contact-tags/new">Create New Contact Tag</Link>
            { this.renderContactTags() }
          </div>
        </AdminPageLayout>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  finishLoading: () => dispatch(appActions.finishLoading()),
});

ContactTagIndexPage.propTypes = {
  finishLoading: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
};

const StyledContactTagIndexPage = styled(ContactTagIndexPage)`
`;

export default connect(
  null,
  mapDispatchToProps,
)(StyledContactTagIndexPage);
